// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".arrow-button[data-v-9ab51bf2]{border-radius:2.5rem;font-size:1.2rem;height:4rem;padding:0 1.5rem}.arrow-button span[data-v-9ab51bf2]{white-space:nowrap}.arrow-button svg[data-v-9ab51bf2]{height:auto;width:1.5rem}@media(max-width:991.98px){.arrow-button[data-v-9ab51bf2]{font-size:.7rem;height:2rem;padding:0 1rem}.arrow-button span[data-v-9ab51bf2]{display:none}.arrow-button svg[data-v-9ab51bf2]{width:.7rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
